import React from 'react';
import * as S from './Preview.styled';
export const Preview = ({ title, description, artworkUrl }) => (React.createElement(S.Container, null,
    React.createElement(S.Artwork, { src: artworkUrl }),
    React.createElement(S.Right, null,
        React.createElement(S.Title, null, title),
        React.createElement(S.Description, null, description))));
